import { makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';

import Home from '../assets/images/svgs/Home';
import ReduceWorkTimeTracking from '../components/ReduceWorkTimeTracking';
import StandardDialog, { StandardDialogInterface } from '../components/StandardDialog';
import { testIDs } from '../consts/testIDs';
import { useWorkingTimeStateContext } from '../context/workingTime/useWorkingTime';
import { goToHome } from '../helpers/navigationHelper';
import { Routes } from '../router/Routes';

interface Props {
	contractID?: number;
	contractNumber?: string;
	workingTimeScreen?: boolean;
	edit?: boolean;
}

function HomeButton({ contractID, contractNumber, workingTimeScreen, edit }: Props) {
	const history = useHistory();
	const classes = useStyles({});
	const { record } = useWorkingTimeStateContext();
	const dialogRef = React.useRef<null | StandardDialogInterface>(null);
	const { t } = useTranslation();

	const onHomePress =
		//@ts-ignore
		(event: MouseEvent<HTMLAnchorElement, MouseEvent>) => {
			if (edit) {
				event.preventDefault();
				dialogRef.current?.setDialogState(true);
			}
		};

	const onAcceptDialog = () => goToHome(history);
	const onCancelDialog = () => dialogRef.current?.setDialogState(false);

	return (
		<div className={classes.wrapper} data-testid={testIDs.HOME_BUTTON}>
			{(workingTimeScreen && record?.contractID && contractID === record.contractID) ||
			(workingTimeScreen && !record) ? null : (
				<ReduceWorkTimeTracking contractID={contractID} contractNumber={contractNumber} />
			)}

			<Link className={classes.container} to={Routes.Home} onClick={(event) => onHomePress(event)}>
				<Home />
			</Link>

			<StandardDialog
				onAccept={onAcceptDialog}
				onCancle={onCancelDialog}
				acceptText={t('warning_data_dialog_accept_button')}
				title={t('warning_data_dialog_title')}
				description={t('warning_data_dialog_description')}
				cancleText={t('warning_data_dialog_cancel_button')}
				ref={dialogRef}
				testID={testIDs.STANDARD_DIALOGUE}
				showWarning
			/>
		</div>
	);
}

const useStyles = makeStyles(() => ({
	container: {
		cursor: 'pointer',
	},
	wrapper: {
		display: 'flex',
		alignItems: 'center',
	},
}));

export default HomeButton;
